import React from "react";

import { siteLocationPrefix } from "../../constants";
import { Programs } from "../../models/programsConfig";
import { TestButton } from "./TestButton";
import * as styles from "./TestStyle.module.css";

type TestIDAzureActionsProps = Readonly<{
  email: string;
}>;

export const TestIDAzureActions = ({ email }: TestIDAzureActionsProps) => (
  <div className={styles.idazureActionsWrapper}>
    <h3>ID@Azure Actions</h3>
    <TestButton
      type={Programs.IdAzure}
      url={`${siteLocationPrefix}/test/setCvsApproval?program=${Programs.IdAzure}`}
      title="Pass CVS approval Azure"
    />
    <TestButton
      type={Programs.IdAzure}
      url={`${siteLocationPrefix}/test/setOnboardingDecision`}
      title="Pass Onboarding decision"
    />
    <TestButton
      type={Programs.IdAzure}
      url={`${siteLocationPrefix}/nda/sendNdaIdAzure?onboardinguserid=${email}`}
      title="Send NDA (/sendNdaIdAzure endpoint)"
    />
    <TestButton
      type={Programs.IdAzure}
      url={`${siteLocationPrefix}/test/signNdaIdAzure`}
      title="Force azure sign NDA"
    />
    <TestButton
      type={Programs.IdAzure}
      url={`${siteLocationPrefix}/nda/checkSignatureIdAzure?onboardinguserid=${email}`}
      title="Check NDA signature and mark it on CRM (/checkSignatureIdAzure endpoint)"
    />
    <br />
    <br />
  </div>
);
